import { Link } from 'react-router-dom'
import headshot from '../Images/headshot_profile.png'

export default function Hero () {
    return (
        <div className="hero-section">
            <section className="bg-gradient-to-br from-gray-900 via-indigo-900 to-green-600 dark:bg-gray-900">
                <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">

                    


                    <div className="mr-auto place-self-center lg:col-span-7 lg:ml-10">
                        
                            {/* <img src={headshot} className="h-40"/> */}

                        

                        <div>
                    
                        {/* <p className="max-w-2xl mb-3 font-light text-white tracking-wide lg:mb-4 md:text-lg lg:text-xl dark:text-gray-400">Welcome! </p> */}
                        <h1 className="max-w-2xl mb-3 mt-6 text-4xl text-white font-semibold tracking-normal leading-none md:text-5xl xl:text-6xl dark:text-white">Jason Carmichael</h1>
                        <h1 className="max-w-2xl mb-6 text-3xl text-green-400 font-semibold  leading-none sm:text-4xl dark:text-white" id="mono-text">Frontend UI/UX Developer</h1 >
                        </div>


                        <p className="max-w-2xl mb-6 font-thin leading-relaxed text-gray-200 lg:mb-8  dark:text-gray-400">
                            Thanks for visiting my portfolio!<br></br>
                            <br></br>
                            I'm a Frontend UI/UX Developer with full-stack experience and a solid background in UX Design. Currently, I work with the modern JavaScript tech stack and build projects in ReactJS. Insatiably curious, I am always learning something new––whether deepening my knowledge of React and Tailwind, or upskilling with Next.JS, Typescript, Redux, Vite, and React Native for mobile development.<br></br>
                            <br></br>
                            Check out some of my work!
                        </p>
                        <Link to="/portfolio" className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white bg-green-500 rounded-lg hover:bg-green-600 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                            See my work
                            <svg className="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </Link>
                    </div>
                    {/* <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
                        <img src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/phone-mockup.png" alt="mockup"/>
                    </div>                 */}
                </div>  
            </section>
        </div>
    )
}

